/*
 *******************************************************************************
 * 
 *  Filename:   ./agents/agentContentLists.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Agent for Content List API endpoints.
 *  
 *  Author:     Norman J. Nolasco [ Archetact ]
 *  
 *  Created:    Monday, July 04, 2022 - 12:09:10 AM (CST)
 *  
 *  Notes:
 *  
 *  
 *  Revisions:
 *      07/04/2022  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2022 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import { requests } from './requests';

export const ContentLists = {
    all: () => requests.get('/ContentLists'),
    get: contentlistid => requests.get(`/ContentList/${contentlistid}`),
    create: contentlist => requests.post(`/ContentLists`, contentlist),
    update: (contentlistid, contentlist) => requests.put(`/ContentList/${contentlistid}`, contentlist),
    delete: contentlistid => requests.del(`/ContentList/${contentlistid}`),
};